var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('FactorNav',{attrs:{"selected":_vm.syncedSelected,"root":_vm.factorTree,"single-select":_vm.singleSelect,"selected-factor":_vm.syncedSelectedFactor,"locked-factor":_vm.lockedFactor},on:{"update:selected":function($event){_vm.syncedSelected=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }